import { ROUTE_TYPE_ANTI_PRIVATE, ROUTE_TYPE_PRIVATE } from '../route/route-constants';
import SeedHomePage from '../page/home/SeedHomePage';
import SeedSettingsPage from '../page/settings/SeedSettingsPage';
import SeedFirebaseLoginPage from './authentication/SeedFirebaseLoginPage';
import SeedFirebaseRegisterPage from './authentication/SeedFirebaseRegisterPage';
import SeedFirebaseLoginLinkPage from './authentication/SeedFirebaseLoginLinkPage';
import SeedFirebaseProfilePage from './authentication/SeedFirebaseProfilePage';
import SeedFirebaseResetPasswordPage from './authentication/SeedFirebaseResetPasswordPage';
import SeedFirebaseLoginPhoneNumberPage from './authentication/SeedFirebaseLoginPhoneNumberPage';

const firebaseRoutes = [
  {
    type: ROUTE_TYPE_PRIVATE,
    path: '/',
    titleId: 'seed.home.title',
    exact: true,
    Component: SeedHomePage,
  },
  {
    type: ROUTE_TYPE_PRIVATE,
    path: '/settings',
    titleId: 'seed.settings.title',
    exact: true,
    Component: SeedSettingsPage,
  },
  {
    type: ROUTE_TYPE_PRIVATE,
    path: '/profile',
    titleId: 'seed.firebase.authentication.profile.title',
    exact: true,
    Component: SeedFirebaseProfilePage,
  },
  {
    type: ROUTE_TYPE_ANTI_PRIVATE,
    path: '/login',
    titleId: 'seed.firebase.authentication.login.title',
    exact: true,
    Component: SeedFirebaseLoginPage,
  },
  {
    type: ROUTE_TYPE_ANTI_PRIVATE,
    path: '/login-link',
    titleId: 'seed.firebase.authentication.linkEmail.title',
    exact: true,
    Component: SeedFirebaseLoginLinkPage,
  },
  {
    type: ROUTE_TYPE_ANTI_PRIVATE,
    path: '/reset-password',
    titleId: 'seed.firebase.authentication.resetPassword.title',
    exact: true,
    Component: SeedFirebaseResetPasswordPage,
  },
  {
    type: ROUTE_TYPE_ANTI_PRIVATE,
    path: '/login-phone',
    titleId: 'seed.firebase.authentication.loginPhone.title',
    exact: true,
    Component: SeedFirebaseLoginPhoneNumberPage,
  },
  {
    type: ROUTE_TYPE_ANTI_PRIVATE,
    path: '/register',
    titleId: 'seed.firebase.authentication.register.title',
    exact: true,
    Component: SeedFirebaseRegisterPage,
  },
];

export default firebaseRoutes;
